export const itemComparisonActionTypes = {
  UPDATE_ITEMS_TO_COMPARE: 'UPDATE_ITEMS_TO_COMPARE'
}

export const searchQueryActionTypes = {
  GET_SEARCH_RESULT: 'GET_SEARCH_RESULT'
}